/**
 * AR content for the "Saint-Tropez" private excursion.
 *
 * Role: Arabic (MSA) translation of slugs/saint-tropez.ts, typed `ExcursionPage`
 * for the shared ExcursionSlugView.
 * Dependencies: slug-excursions (type), image. Slug mirrors FR (place name).
 */
import type { ExcursionPage } from "../slug-excursions";
import sttrop from "@/assets/images/excursions/destinations/st-trop.webp";

const page: ExcursionPage = {
  slug: "saint-tropez",
  hero: {
    title: "رحلة سان تروبيه",
    subtitle: "ميناء أسطوري وشواطئ وأزقّة بروفنسية، في هدوء تام.",
    ctaPrimaryHref: "/reservation",
    ctaPrimaryLabel: "احجز الآن",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "اطلب عرض سعر",
    image: sttrop,
  },
  highlights: {
    title: "أبرز المعالم",
    items: [
      { text: "ميناء سان تروبيه واليخوت والمقاهي الأسطورية" },
      { text: "القلعة والأزقّة البروفنسية النموذجية" },
      { text: "شواطئ بامبلون القريبة" },
      { text: "إطلالات ساحلية على طريق الفار" },
    ],
  },
  itinerary: {
    title: "برنامج مقترح",
    steps: [
      {
        title: "الطريق من كان إلى سان تروبيه",
        description: "مناظر ساحلية في منطقة الفار.",
      },
      {
        title: "المركز التاريخي",
        description: "الميناء والقلعة (اختياري) والمتاجر.",
      },
      {
        title: "وقت حر",
        description: "استراحة قهوة وشاطئ حسب الموسم.",
      },
      {
        title: "بامبلون (اختياري)",
        description: "سباحة / شاطئ خاص حسب الموسم.",
      },
    ],
  },
  practical: {
    title: "معلومات عملية",
    items: [
      { label: "المدة", value: "من 6 إلى 8 ساعات" },
      { label: "نصيحة", value: "تجنّب ساعات الذروة في الصيف" },
      { label: "الانطلاق", value: "كان" },
      { label: "خيار", value: "شاطئ بامبلون / القلعة" },
    ],
  },
};

export default page;
